import React, { Suspense, lazy } from 'react';
import { IconAsChunk } from '@boschebike/ebds-react-icons';
import Button from './Button.js';
const zoomPanPinch = async () => import('react-zoom-pan-pinch');
const TransformComponentPromise = async () => {
  const module = await zoomPanPinch();
  return {
    default: module.TransformComponent
  };
};
const TransformWrapperPromise = async () => {
  const module = await zoomPanPinch();
  return {
    default: module.TransformWrapper
  };
};
const TransformImage = ({
  image,
  imageTools = false,
  imageLimitToBounds = true,
  imageZoomWheelDisabled = false,
  imageZoomDoubleClickDisabled = false,
  imagePanningDisabled = false
}) => {
  const TransformWrapper = /*#__PURE__*/lazy(TransformWrapperPromise);
  const TransformComponent = /*#__PURE__*/lazy(TransformComponentPromise);
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement("div", {
    className: "ebds-transform-image-container"
  }, /*#__PURE__*/React.createElement(TransformWrapper, {
    limitToBounds: imageLimitToBounds,
    wheel: {
      disabled: imageZoomWheelDisabled
    },
    doubleClick: {
      disabled: imageZoomDoubleClickDisabled
    },
    panning: {
      disabled: imagePanningDisabled
    }
  }, ({
    zoomIn,
    zoomOut,
    resetTransform
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, imageTools && /*#__PURE__*/React.createElement("div", {
    className: "ebds-transform-image-container__tools"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => zoomIn(),
    text: "Zoom In",
    icon: /*#__PURE__*/React.createElement(IconAsChunk, {
      iconName: "ZoomIn"
    })
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: () => zoomOut(),
    text: "Zoom Out",
    icon: /*#__PURE__*/React.createElement(IconAsChunk, {
      iconName: "ZoomOut"
    })
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: () => resetTransform(),
    text: "Reset",
    icon: /*#__PURE__*/React.createElement(IconAsChunk, {
      iconName: "Reset"
    })
  })), /*#__PURE__*/React.createElement(TransformComponent, null, image)))));
};
export default TransformImage;